// Het venster met alles van een soort uit de winkel (29-9-2026, C428). Stond eerst binnen km-agenda.js;
// nu een los onderdeel, zodat de agenda (Wat er op de kraam ligt) en de homepage (Iets moois mee naar
// huis) precies hetzelfde venster gebruiken. Een wijziging hier geldt voor allebei.
//
// Gebruik: kmKraamVenster.open(handle, titel, domein, { kleuren, nieuwTabblad, groepen, meerLink })
//   handle        de categorie in Shopify
//   domein        leeg voor onze eigen winkel, of bijvoorbeeld https://cutiepix.nl voor het knutselmateriaal
//   kleuren       de kleurcodes voor de bolletjes (snippets/km-kleuren-json.liquid)
//   nieuwTabblad  standaard true: de agenda moet blijven staan. Op de homepage false.
//   groepen       [{handle, titel}]: meerdere soorten onder elkaar in één venster (handle is dan alleen een naam)
//   meerLink      bij een groep: waar Alles bekijken heen gaat, standaard /collections/all
// kmKraamVenster.sluit() en kmKraamVenster.isOpen(). Escape sluit het venster, en alleen het venster.
(function () {
  'use strict';
  if (window.kmKraamVenster) return;

  function ic(path) {
  return '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }
  var IC = {
  ext: ic('<path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>'),
  x: ic('<path d="M18 6 6 18M6 6l12 12"/>'),
  tag: ic('<path d="M4 4h7l9 9-7 7-9-9z"/><circle cx="8" cy="8" r="1.2" fill="currentColor" stroke="none"/>')
  };
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function euro(n) { return '\u20ac' + Number(n).toFixed(2).replace('.', ','); }

  var kraamOv = null;
  var kleurenCfg = {};

  // Een kleurbolletje wisselt de voor- en achterkant van dat kledingstuk.
  // Het bolletje staat naast de link en niet erin, want een knop in een link
  // is geen geldige opbouw en gedraagt zich per browser anders.
  function wisselKleur(e) {
    var bol = e.target.closest('.kmkrkleur');
    if (!bol) return false;
    var kaart = bol.closest('.kmkritem');
    var vlak = kaart.querySelector('.kmkrf');
    var rug = kaart.querySelector('.kmkrb');
    var voor = bol.getAttribute('data-voor');
    var achter = bol.getAttribute('data-achter');
    if (vlak && voor) vlak.style.backgroundImage = 'url(' + voor + ')';
    if (rug) {
      if (achter) { rug.style.backgroundImage = 'url(' + achter + ')'; rug.style.display = ''; }
      else rug.style.display = 'none';
    }
    kaart.querySelectorAll('.kmkrkleur').forEach(function (b) { b.classList.remove('aan'); });
    bol.classList.add('aan');
    return true;
  }

  function maak() {
    if (kraamOv) return;
    kraamOv = document.createElement('div');
    kraamOv.className = 'kmkrov';
    kraamOv.innerHTML = '<div class="kmkrbox" role="dialog" aria-modal="true" aria-labelledby="kmkr-titel">' +
      '<div class="kmkrkop"><h3 class="kmkrtitel" id="kmkr-titel"></h3>' +
      '<button type="button" class="kmkrsluit" data-kraam-sluit aria-label="Sluiten">' + IC.x + '</button></div>' +
      '<div class="kmkrbody" data-kraam-body></div>' +
      '<div class="kmkrvoet" data-kraam-voet></div></div>';
    document.body.appendChild(kraamOv);
    kraamOv.addEventListener('click', function (e) {
      if (wisselKleur(e)) return;
      if (e.target === kraamOv || e.target.closest('[data-kraam-sluit]')) sluitKraam();
    });
  }

  // De tegels met foto, naam, prijs en kleurbolletjes. Staan buiten het venster, zodat ook het venster bij
  // de dieren op de homepage ze gebruikt (29-9-2026, C447): een wijziging hier geldt voor allebei.
  // Shopify levert de foto's op ware grootte - bij de placemats 5000 bij 5000.
  // Laat je de browser dat zelf verkleinen naar 132 punten, dan wordt fijne
  // lijnkunst korrelig en haalt elke bezoeker megabytes binnen voor niets.
  // Met deze maat verkleint Shopify zelf, netjes en klein.
  function fotoOpMaat(src, breedte) {
    if (!src) return '';
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breedte;
  }

  // Bij kleding hangt aan elke kleur een voorkant en een achterkant. Shopify
  // hangt de variant-nummers aan de voorkantfoto; de foto die er direct achter
  // staat is de achterkant van diezelfde kleur. Zo halen we per kleur het paar
  // eruit, zonder dat er ergens een lijst met bestandsnamen bijgehouden hoeft.
  function kleurenVan(p) {
    var opt = (p.options || []).filter(function (o) { return /kleur/i.test(o.name); })[0];
    if (!opt) return [];
    var welke = 'option' + ((p.options.indexOf(opt)) + 1);
    var paletNaam = /hoodie/i.test(p.product_type) ? 'hoodie'
                  : /t-shirt|shirt/i.test(p.product_type) ? 't-shirt' : 'algemeen';
    var palet = (kleurenCfg && (kleurenCfg[paletNaam] || kleurenCfg.algemeen)) || {};
    var perVariant = {};
    (p.variants || []).forEach(function (v) { perVariant[v.id] = v; });

    return opt.values.map(function (naam) {
      var voor = '', achter = '';
      (p.images || []).forEach(function (img, i) {
        if (voor || !img.variant_ids || !img.variant_ids.length) return;
        var hoort = img.variant_ids.some(function (id) {
          var v = perVariant[id];
          return v && String(v[welke]).toLowerCase() === String(naam).toLowerCase();
        });
        if (!hoort) return;
        voor = img.src;
        var volgende = p.images[i + 1];
        if (volgende && (!volgende.variant_ids || !volgende.variant_ids.length)) achter = volgende.src;
      });
      var teKoop = (p.variants || []).some(function (v) {
        return v.available && String(v[welke]).toLowerCase() === String(naam).toLowerCase();
      });
      return { naam: naam, voor: voor, achter: achter, code: palet[String(naam).toLowerCase()] || '', teKoop: teKoop };
    }).filter(function (k) { return k.voor; });
  }

  // Kinderkleding en volwassenkleding door elkaar is zoeken. Het producttype
  // zegt het al ("T-shirt Kind", "Hoodie Volwassenen"), dus daar splitsen we op.
  // Staat er maar een soort in, dan blijft het gewoon een rijtje zonder kopjes.
  function voorWie(p) {
    var t = (p.product_type || '') + ' ' + (p.title || '');
    if (/\bkind(er|eren)?\b/i.test(t)) return 'kind';
    if (/\bvolwassen(en)?\b/i.test(t)) return 'volwassen';
    return '';
  }

  function rooster(lijst, basis, doel) {
    return '<div class="kmkrgrid">' + lijst.map(function (p) {
      // De laagste prijs van wat er nog te krijgen is; staat alles op nul, dan
      // de gewone laagste prijs, zodat er nooit een leeg bedrag staat.
      var teKoop = p.variants.filter(function (v) { return v.available; });
      var uit = teKoop.length === 0;
      var bron = uit ? p.variants : teKoop;
      var laagste = Math.min.apply(null, bron.map(function (v) { return parseFloat(v.price); }));
      var meer = bron.length > 1 && Math.max.apply(null, bron.map(function (v) { return parseFloat(v.price); })) > laagste;
      var kleuren = kleurenVan(p);
      var start = kleuren.filter(function (k) { return k.teKoop; })[0] || kleuren[0] || null;
      var voor = start ? start.voor : ((p.images && p.images[0]) ? p.images[0].src : '');
      var achter = start ? start.achter : '';

      var beeld = voor
        ? '<span class="kmkrf" style="background-image:url(' + esc(fotoOpMaat(voor, 400)) + ')">' +
            (achter ? '<span class="kmkrb" style="background-image:url(' + esc(fotoOpMaat(achter, 400)) + ')"></span>' : '') +
          '</span>'
        : '<span class="kmkrf kmkrf-leeg">' + IC.tag + '</span>';

      var stippen = '';
      if (kleuren.length > 1) {
        stippen = '<div class="kmkrkleuren">' + kleuren.map(function (k, i) {
          return '<button type="button" class="kmkrkleur' + (k === start ? ' aan' : '') + (k.teKoop ? '' : ' op') + '"' +
            ' data-voor="' + escAttr(fotoOpMaat(k.voor, 400)) + '"' +
            ' data-achter="' + escAttr(fotoOpMaat(k.achter, 400)) + '"' +
            ' style="background:' + esc(k.code || '#DDE6EA') + '"' +
            ' aria-label="' + escAttr(k.naam + (k.teKoop ? '' : ': uitverkocht')) + '"' +
            ' title="' + escAttr(k.naam + (k.teKoop ? '' : ': uitverkocht')) + '"></button>';
        }).join('') + '</div>';
      }

      // Kaatje&Mup producten krijgen het crème kaartje van de homepage (C459); andere merken, zoals de
      // knutselspullen van Cutiepix, houden het witte vakje.
      var eigen = (p.tags || []).some(function (t) { return /^merk:\s*kaatje&mup$/i.test(String(t).trim()); });
      return '<div class="kmkritem' + (eigen ? ' kmkritem--km' : '') + '">' +
        // Altijd een nieuw tabblad: de agenda moet blijven staan, ook als
        // iemand doorklikt naar een product.
        '<a class="kmkrlink" href="' + esc(basis) + '/products/' + esc(p.handle) + '"' + doel + '>' +
          beeld +
          '<span class="kmkrt">' + esc(p.title) + '</span>' +
          '<span class="kmkrp">' + (meer ? 'vanaf ' : '') + euro(laagste) +
          (uit ? ' <span class="kmkruit">uitverkocht</span>' : '') + '</span>' +
        '</a>' + stippen +
        '</div>';
    }).join('') + '</div>';
  }

  // Het venster met alles van een soort. Het staat over de pop-up van de
  // voorstelling heen, precies zoals het fotovenster dat al bestond, zodat de
  // bezoeker met een druk op Escape weer terug is bij zijn kaartje.
  //
  // De producten worden pas opgehaald als iemand klikt. Ze allemaal vooraf
  // meesturen zou betekenen dat elke bezoeker van de agenda de gegevens van
  // zeventig producten binnenhaalt om er meestal nul te bekijken.
  var kraamCache = {};
  function sluitKraam() { if (kraamOv) kraamOv.classList.remove('open'); }
  function openKraam(handle, titel, domein, opties) {
    opties = opties || {};
    maak();
    if (opties.kleuren) kleurenCfg = opties.kleuren;
    var doel = opties.nieuwTabblad === false ? '' : ' target="_blank" rel="noopener"';
    // domein is leeg voor onze eigen spullen (dan blijft alles op deze site) en
    // gevuld voor het knutselmateriaal, dat in de winkel van Cutiepix staat.
    var basis = (domein || '').replace(/\/+$/, '');
    var body = kraamOv.querySelector('[data-kraam-body]');
    var voet = kraamOv.querySelector('[data-kraam-voet]');
    kraamOv.querySelector('.kmkrtitel').textContent = titel;
    kraamOv.classList.add('open');
    voet.innerHTML = '<a class="kmkrmeer" href="' + esc(basis) + '/collections/' + esc(handle) + '"' + doel + '>' +
      'Alles bekijken in de webshop' + (doel ? ' ' + IC.ext : '') + '</a>';

    function teken(lijst) {
      if (!lijst.length) { body.innerHTML = '<p class="kmkrleeg">Hier ligt op dit moment niets.</p>'; return; }
      var kind = lijst.filter(function (p) { return voorWie(p) === 'kind'; });
      var volw = lijst.filter(function (p) { return voorWie(p) === 'volwassen'; });
      var rest = lijst.filter(function (p) { return !voorWie(p); });
      if (kind.length && volw.length) {
        body.innerHTML =
          '<h4 class="kmkrgroep">Voor kinderen</h4>' + rooster(kind, basis, doel) +
          '<h4 class="kmkrgroep">Voor volwassenen</h4>' + rooster(volw, basis, doel) +
          (rest.length ? '<h4 class="kmkrgroep">Verder</h4>' + rooster(rest, basis, doel) : '');
        return;
      }
      body.innerHTML = rooster(lijst, basis, doel);
    }

    // Een groep (30-9-2026, C458): meerdere soorten in één venster, elk onder een eigen kopje dat naar
    // die soort in de webshop linkt. Carolien: "Kleurplaat producten moet een groep zijn waar dan de
    // kleurplaat placemats, kleurboeken en kleurkaarten in moeten komen te staan". Een lege soort valt weg.
    if (opties.groepen && opties.groepen.length) {
      voet.innerHTML = '<a class="kmkrmeer" href="' + esc(basis) + (opties.meerLink || '/collections/all') + '"' + doel + '>' +
        'Alles bekijken in de webshop' + (doel ? ' ' + IC.ext : '') + '</a>';
      body.innerHTML = '<p class="kmkrladen">Even kijken wat er ligt…</p>';
      Promise.all(opties.groepen.map(function (g) {
        if (kraamCache[g.handle]) return Promise.resolve(kraamCache[g.handle]);
        return fetch('/collections/' + encodeURIComponent(g.handle) + '/products.json?limit=50')
          .then(function (r) { return r.json(); })
          .then(function (d) { var l = (d && d.products) || []; kraamCache[g.handle] = l; return l; })
          .catch(function () { return []; });
      })).then(function (lijsten) {
        var h = '';
        opties.groepen.forEach(function (g, i) {
          if (!lijsten[i].length) return;
          h += '<h4 class="kmkrgroep"><a href="' + esc(basis) + '/collections/' + esc(g.handle) + '"' + doel + '>' +
            esc(g.titel) + '</a></h4>' + rooster(lijsten[i], basis, doel);
        });
        body.innerHTML = h || '<p class="kmkrleeg">Hier ligt op dit moment niets.</p>';
      });
      return;
    }

    if (kraamCache[handle]) { teken(kraamCache[handle]); return; }
    body.innerHTML = '<p class="kmkrladen">Even kijken wat er ligt…</p>';
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var lijst = (d && d.products) || [];
        kraamCache[handle] = lijst;
        teken(lijst);
      })
      .catch(function () {
        body.innerHTML = '<p class="kmkrleeg">Het lukte even niet om de spullen op te halen. ' +
          'Je kunt ze wel bekijken via de link hieronder.</p>';
      });
  }

  // In de vangfase, zodat Escape alleen dit venster sluit en niet ook het venster eronder.
  document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && kraamOv && kraamOv.classList.contains('open')) {
    sluitKraam();
    e.stopImmediatePropagation();
  }
  }, true);

  window.kmKraamVenster = {
    open: openKraam,
    sluit: sluitKraam,
    isOpen: function () { return !!kraamOv && kraamOv.classList.contains('open'); },
    // Voor een ander venster met dezelfde tegels (C447): de html voor een lijst producten in de vorm van
    // /products.json, en een klik doorgeven zodat de kleurbolletjes werken.
    tegels: function (lijst, opties) {
      opties = opties || {};
      if (opties.kleuren) kleurenCfg = opties.kleuren;
      var doel = opties.nieuwTabblad === false ? '' : ' target="_blank" rel="noopener"';
      return rooster(lijst, (opties.domein || '').replace(/\/+$/, ''), doel);
    },
    klik: wisselKleur
  };
})();
